import { useEffect, useState } from "react";

function isLocalStorageAvailable() {
    var test = "test";
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

export default function useLocalStorage(
    key: string,
    defaultValue: string | null = null
): [string | null, React.Dispatch<React.SetStateAction<string | null>>] {
    const [value, setValue] = useState<string | null>(
        localStorage.getItem(key) || defaultValue
    );

    useEffect(() => {
        if (isLocalStorageAvailable()) {
            if (value) {
                localStorage.setItem(key, value);
            }
        }
    }, [value]);

    return [value, setValue];
}
